import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "maintain",
  "use": "maintain-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"maintain\"><path d=\"M11.696 0L8.869 1.823l.603 2.253-5.44 5.435-2.062-.836L0 11.701l.721 2.15 1.777-1.8 1.077.357.402 1.185-1.731 1.728 2.06.679 3.038-2.007-.876-1.957L11.97 6.54l1.771.856L16 4.299l-.71-2.14-1.757 1.788-1.087-.365-.53-1.207L13.672.584z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id